const ROUTE_VIEW_RECORD = [
  { path: '/record/register', name: '挂号记录', h5Uri: '/record/record_register', nativeUri: null, whiteList: false },
  { path: '/record/detailsregister', name: '挂号详情', h5Uri: '/record/record_detailsregister', nativeUri: null, whiteList: false },
  { path: '/record/check', name: '检验检查记录', h5Uri: '/record/record_check', nativeUri: null, whiteList: false },
  { path: '/record/prescription', name: '处方记录', h5Uri: '/record/record_prescription', nativeUri: null, whiteList: false }

]

export default ROUTE_VIEW_RECORD



// WEBPACK FOOTER //
// ./src/router/mapping/record.js